import * as React from "react";
import "./index.css";
import { useDispatch } from "react-redux";
import { Tab, Tabs } from "@mui/material";

const TabsComponent = ({ tabs, withImage, setSelectedTab, selectedTab, navFunc }) => {
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    if (tabs?.[newValue]?.disabled) {
      return;
    }
    if (navFunc) {
      navFunc(newValue);
    }
    dispatch(setSelectedTab(newValue));
  };

  return (
    <div>
      <div className="tabs-container">
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          TabIndicatorProps={{ style: { backgroundColor: "#FFCC33" } }}
          aria-label="dashboard tabs"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '1rem',
              color: '#000',
            },
            '& .Mui-selected': {
              color: '#000',
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              icon={withImage ? tab.img : ''}
              iconPosition="start"
              label={tab.name}
              disabled={Boolean(tab.disabled)}
              key={index}
            />
          ))}
          <div className="tabs-bottom-border">&nbsp;</div>
        </Tabs>
      </div>
    </div>
  );
};

export default TabsComponent;
